export const HEADER = {
  logo: {
    src: null,
    alt: "Zobayer H.",
  },
  menus: [
    {
      name: "Home",
      to: "Hero",
    },
    {
      name: "About",
      to: "About",
    },
    {
      name: "Resume",
      to: "Resume",
    },
    {
      name: "Works",
      to: "Portfolio",
    },
    {
      name: "Blogs",
      to: "Blogs",
    },
    {
      name: "Contact",
      to: "Contact",
    },
  ],
};
